import RestCreate from 'containers/rest/Create';
import Form from '../components/RelatedSKUsForm';

const breadcrumbs = [
   {
      title: 'common.page.settings',
      href: '/settings',
    },
    {
       title: 'common.page.variantRelated',
       href: '/settings/manage-related-skus',
    },
   {
      title: 'common.page.create',
   },
];

export default function RelatedSKUsCreate() {

   return (
      <RestCreate
         model="variantRelated"
         breadcrumbs={breadcrumbs}
         customPathAfterSubmit="settings/manage-related-skus"
         hasSelectFilter={false}
         customUrlBack="/settings/manage-related-skus"
         formatOnSubmit={(value) => {
            const convertData = value?.productVariantRelateds?.map((item) => ({
               originalVariantSku: value?.originalVariantSku,
               relatedVariantSku: item?.relatedVariantSku,
               priority: item?.priority
            })) || [];
            
            return ({
               productVariantRelateds: [
                  {
                     originalVariantSku: value?.originalVariantSku,
                     relatedVariantSku: value?.originalVariantSku,
                     priority: value?.originalPriority,
                  },
                  ...convertData,
               ]
            })
         }}
      >
        <Form />
      </RestCreate>
    );
}